<template>
  <AuthLayout show-legal wide :loading="loading" bg-image="plan-view">
      <div class="max-w-[1200px]">
          <div class="absolute right-8 top-4">
              <a href="/logout">
                  <Button icon="pi pi-sign-out" text rounded severity="contrast"></Button>
              </a>
          </div>
          <div class="max-w-md">
              <h2 class="text-2xl font-bold text-gray-900 dark:text-neutral-200">Vyberte si edici, která vám přinese nejvíce užitku</h2>
              <p class="mt-1 text-sm text-gray-500 dark:text-neutral-200">
                  Naše plány jsou navrženy tak, aby vyhovovaly různým potřebám. Zvolte si ten, který odpovídá vašim cílům a využijte všechny možnosti, které Roori nabízí.
              </p>
              <SelectButton v-model="selectedPricing" :options="pricingSelector" :allow-empty="false" option-label="label" option-value="value" size="small" class="mt-5 shadow-lg"></SelectButton>

          </div>
          <div class="flex max-md:flex-col  gap-4 mt-8">
              <div v-for="(plan, index) in pricingPlans" :key="index" class="dark:border-neutral-700 border p-8 rounded-3xl w-full md:max-w-[400px]" :class="plan.featured ? 'border-blue-500 border-2 ring' : ''">
                  <p class="text-roori-blue font-medium text-lg mb-4">{{ plan.name.split(' ')[1] }}</p>
                  <div class="text-sm text-gray-600 dark:text-gray-300 mb-3" v-html="plan.description"></div>

                  <p class="text-2xl font-semibold mb-4 flex gap-1">
                      <span>{{ selectedPricing === 'monthly' ? plan.price : plan.price_yearly }}</span>
                      <span v-if="index > 0" class="text-lg opacity-50 mt-1"> {{ selectedPricing === 'monthly' ? 'měsíčně' : 'ročně' }}</span>
                  </p>
                  <template v-if="plan.button?.slug !== null">
                      <Button
                          fluid
                          @click="router.visit(`/register/${plan.button?.slug[selectedPricing]}`)"
                          :label="plan.button.label"
                          :variant="plan.button.variant"
                          :severity="plan.button.severity"
                      />
                  </template>

                  <ul class="text-sm mt-8 flex flex-col gap-4 grow">
                      <li v-for="(feature, i) in plan.features" :key="i" class="flex items-center gap-2">
                          <i class="pi pi-check text-roori-blue"></i>
                          {{ feature }}
                      </li>
                  </ul>
              </div>
          </div>
      </div>

  </AuthLayout>
</template>
<script setup>
import {
    onBeforeMount, onMounted,
    ref
} from 'vue';
import SelectButton from 'primevue/selectbutton';
import Button from 'primevue/button';
import AuthLayout from '../components/view-components/AuthLayout.vue';
import {usePage, Link, router} from "@inertiajs/vue3";


const page = usePage();
const loading = ref(false);
const pricingPlans = ref([]);
const pricingSelector = ref([{
  label: 'Měsíční',
  value: 'monthly'
},
  {
    label: 'Roční',
    value: 'yearly'
  }
]);
const selectedPricing = ref('monthly');
const startingCss = 'border md:border-r-0 max-md:border-b-0 md:rounded-l-2xl max-md:rounded-t-2xl max-md:mx-4 p-5 price md:w-1/4 side-card flex flex-col';
const middleCss = 'md:border-t border-b max-md:border-l border-r p-5 price max-md:mx-4 md:w-1/4 side-card flex flex-col ';
const endingCss = 'md:border-t border-b max-md:border-l border-r p-5 price md:rounded-r-2xl max-md:rounded-b-2xl max-md:mx-4 md:w-1/4 side-card flex flex-col';
const featuredCss = 'border bg-white dark:bg-black md:rounded-2xl max-md:bg-neutral-100 md:shadow-lg p-5 price md:w-1/4 main-card flex flex-col';


const language = 'cs';
const invoicingArea = 'CZ';
onMounted(() => {
    Object.values(page.props.plans)?.forEach((item, i) => {
        const priceMonthly = item.plans?.filter(plan => plan.periodicity_type === 'Month' && plan.invoicing_area === invoicingArea);
        const priceYearly = item.plans?.filter(plan => plan.periodicity_type === 'Year' && plan.invoicing_area === invoicingArea);
        pricingPlans.value.push({
            name: item.name,
            description: item.description[language],
            featured: item.featured,
            features: item.edition_features?.map(feature => {
                return feature.feature[language]
            }),
            price: priceMonthly.length ? (priceMonthly[0].price === 0 ? 'Zdarma' : Intl.NumberFormat(language, { style: 'currency', currency: priceMonthly[0].currency }).format(priceMonthly[0].price)) : null,
            price_yearly: priceYearly.length ? (priceYearly[0].price === 0 ? 'Zdarma' : Intl.NumberFormat(language, { style: 'currency', currency: priceYearly[0].currency }).format(priceYearly[0].price)) : null,
            button: { label: "Vybrat", variant: item.featured ? null : 'outlined', slug: priceMonthly[0]?.slug ? { 'monthly': priceMonthly[0]?.slug, 'yearly': priceYearly[0]?.slug } : null },
            classes: item.featured ? featuredCss : ( i === 0 ? startingCss : ( i === page.props.plans.length - 1 ) ? endingCss : middleCss ),
        })
        })
})
</script>
<style scoped>
.main-card {
    height: 440px;
}
.side-card {
    height: 380px;
}
</style>
